import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TerminaisService } from "./terminais.service";
import { TerminaisModel } from "./terminais.model";
import { Global } from "../global";
import { Components } from "../shared/components/components";
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { Funcoes } from "../funcoes";
import { LoginService } from "../login/login.service";

declare var swal, $: any;

@Component({
  selector: 'app-terminais',
  templateUrl: './terminais.component.html'
})
export class TerminaisComponent extends Components implements OnInit {

  terminais: TerminaisModel[] = [];
  privilegioUsuario = { "editar": false, "consultar": false };

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = { "nome": "" };

  constructor(
    formBuilder: FormBuilder,
    private terminaisService: TerminaisService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes,
    private loginService: LoginService
  ) {
    super();

    this.formPesquisaAvancada = formBuilder.group({
      nome: []
    });

    this.loginService.getUserInfo().subscribe(data => {
      for (let i in data.privilegios) {
        if (data.privilegios[i].id_acao == '27') {
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });
  }

  ngOnInit() {
    // busca filtro salvo no localStorage
    let filtroSalvo = this.carregaFiltro();
    if (filtroSalvo) {
      this.filtroPesquisa = filtroSalvo;
      this.formPesquisaAvancada.patchValue(filtroSalvo);
    }

    this.getPage(1);
  }

  delete(terminal) {
    let terminais = this.terminais;
    let terminaisService = this.terminaisService;
    let self = this;
    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.desejaDeletarTerminal') + terminal.nome,
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
      function () {
        if (self.global.debug == true) {
          console.log(terminais);
        }

        let index = terminais.indexOf(terminal);
        terminais.splice(index, 1);

        terminaisService.apagar(terminal.id)
          .subscribe(res => {
            self.terminais = terminais;
          },
            err => {
              terminais.splice(index, 0, terminal);
              self.terminais = terminais;
              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina) {
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};
    if (this.filtroPesquisa.nome != '') {
      filtros['nome'] = "**:" + this.filtroPesquisa.nome;
    }

    this.terminaisService.getPaginacao(pagina, this.itensPorPagina, null, filtros)
      .subscribe(data => {
        this.terminais = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;
      },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  modalPesquisaAvancada() {
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada() {
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada() {
    this.filtroPesquisa = { "nome": "" };
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

}




// WEBPACK FOOTER //
// ./src/app/terminais/terminais.component.ts